import { Button } from 'app/components/common/BaseButton/styles'
import { BaseTable } from 'app/components/common/BaseTable'
import styled from 'styled-components'

export const ButtonHistory = styled(Button)<{
  $border?: string;
  $background?: string;
}>`
  border: initial;
  box-shadow: initial;
  margin-left: 5px;
`

export const ButtonHistoryStatus = styled(Button)<{
  $border?: string;
  $background?: string;
}>`
  border: initial;
  box-shadow: initial;
  margin-left: 5px;
  color: ${props => props?.$border};
  background: ${props => props?.$background};
  font-weight: bold;
  border-radius: 20px;
  font-size: 10px;
  line-height: 14px;
  padding: 4px 12px;
`

export const HistoryTable = styled(BaseTable)`
  .ant-table-thead {
    border-bottom: 1px solid #f4f6f9;
  }

  .ant-table-thead .ant-table-cell {
    border: initial;
    text-align: center;

    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    opacity: 0.5;
    color: var(--main-color-text);
  }

  .ant-table-thead tr > *:first-child {
    text-align: left;
  }
  .ant-table-cell {
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 133.333% */
    color: var(--main-color-text);
    opacity: 0.7;
    padding: 5px !important;
  }
`

export const HistoryTitle = styled(Button)`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  opacity: 0.7;
  color: var(--main-color-text);
  border: initial;
  padding: 5px;
`

export const HistoryText = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  color: var(--main-color-text);
  opacity: 0.7;
  text-align: left;
`

export const HistoryUser = styled.p`
  min-width: 220px;
`
